/* Remote session history and the live session list. docs/04-data-model.md F.3. */

import { request } from '../client';
import { isMockTransport } from '../config';
import type { RemoteSession } from '../types';

export async function listSessions(): Promise<readonly RemoteSession[]> {
  if (isMockTransport()) {
    const { mockListSessions } = await import('@/mocks/handlers');
    return mockListSessions();
  }
  return request<readonly RemoteSession[]>('/sessions');
}
